import { RNAction, RNEvent } from './constants';
import { send2RN } from './actions';
import { onRN } from './events';

export const useOnGoBack = (cb?: () => void) => {
  const defaultAction = () => {
    send2RN(RNAction.goBack);
  };
  onRN(RNEvent.onBack, cb || defaultAction);

  return () => {
    onRN(RNEvent.onBack, defaultAction);
  };
};
